import { MAX_DISCOUNT_PCT } from "./limits.js";
/**
 * Package rules that are VALUES, not shapes.
 *
 * Kept out of `admin-views.ts`, which declares itself free of runtime values
 * and is held to that by `test/source-hygiene.test.ts`: a module that says it
 * emits nothing must emit nothing. (Not quoted here word for word -- the gate
 * reads the header's literal words, and a quotation would be a claim.)
 */
/**
 * The integer bounds on every numeric field of a package, INCLUSIVE.
 *
 * ONE TABLE, READ BY BOTH SIDES. The worker refuses outside it; the panel
 * checks against it so the refusal lands under the box that caused it. It used
 * to live in `routes/admin.ts` while the panel hand-copied the floor of one
 * field and none of the ceilings -- so `sort: 99999` passed the form and came
 * back as a line of text naming a column.
 *
 * Sanity, not policy: 3650 days is ten years and $100,000 is a typo. They
 * exist so a slipped keyboard cannot write a number the storefront renders.
 * NOT in `limits.ts`, which holds the limits the schema also CHECKs. The one
 * field here that is one, `discount_pct`, takes its ceiling from there.
 */
export const PACKAGE_NUMBERS = {
    data_mb: [0, 10_000_000],
    sms_count: [0, 1_000_000],
    voice_minutes: [0, 1_000_000],
    validity_days: [1, 3650],
    cost_cents: [0, 10_000_000],
    retail_cents: [0, 10_000_000],
    discount_pct: [0, MAX_DISCOUNT_PCT],
    sort: [0, 10_000],
};
/**
 * Whether a cost check found a cost to write: the supplier's price is known
 * and is not the stored one. The worker writes exactly these rows and the
 * panel offers exactly these, so the two cannot disagree about which.
 */
export function costMoves(row) {
    return row.changeCents !== null && row.changeCents !== 0;
}
//# sourceMappingURL=packages.js.map